import { labelDefaultMediumStyles, labelDefaultRegularStyles } from '@lifebit-ai/lds'
import styled, { css } from 'styled-components'

const columnLayoutStyles = css`
  display: flex;
  flex-direction: column;
`

const textWrapStyles = css`
  white-space: pre-wrap;
  word-break: break-word;
`

const labelMediumMainStyles = css`
  ${labelDefaultMediumStyles}
  color: ${({ theme }) => theme.color.content.main};
`

const labelRegularMainStyles = css`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.main};
`

const labelRegularSecondaryStyles = css`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.secondary};
`

export const FormContent = styled.div`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['05']};
  padding: ${({ theme }) => theme.size.space['01']};
`

export const FormHeader = styled.h3`
  ${labelMediumMainStyles}
  margin: 0;
`

export const LogoContainer = styled.div`
  width: ${({ theme }) => theme.size.space['11']};
  height: ${({ theme }) => theme.size.space['11']};
  border-radius: ${({ theme }) => theme.size.border.radius.round};
  overflow: hidden;
`

export const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`

export const Block = styled.section`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['02']};
`

export const BlockTitle = styled.h3`
  margin: 0;
`

export const BlockFields = styled.div`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['06']};
`

export const TextField = styled.div`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['02']};
`

export const GroupField = styled(TextField)``

export const FieldLabel = styled.span`
  ${labelMediumMainStyles}
`

export const FieldValue = styled.p`
  ${labelRegularMainStyles}
  margin: 0;
  ${textWrapStyles}
`

export const FieldHelpText = styled.p`
  ${labelRegularSecondaryStyles}
  margin: 0;
  ${textWrapStyles}
`

export const EmptyText = styled.span`
  ${labelRegularSecondaryStyles}
`

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.size.space['02']};
`

export const CheckboxField = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['03']};
  padding: ${({ theme }) => theme.size.space['03']} ${({ theme }) => theme.size.space['04']};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
`

export const CheckboxIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.size.icon.small};
  height: ${({ theme }) => theme.size.icon.small};
  color: ${({ theme }) => theme.color.feedback.success.default};
`

export const CheckboxFieldText = styled.span`
  ${labelDefaultRegularStyles}
  color: ${({ theme }) => theme.color.content.main};
`

export const CheckboxGroup = styled.div`
  ${columnLayoutStyles}
  padding: ${({ theme }) => theme.size.space['02']};
  border: 1px solid ${({ theme }) => theme.color.border.subtle};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
`

export const UploadedFiles = styled.div`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['03']};
  padding: ${({ theme }) => theme.size.space['03']};
  border: 1px solid ${({ theme }) => theme.color.border.subtle};
  border-radius: ${({ theme }) => theme.size.border.radius['04']};
`

export const UploadedFileRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.size.space['03']};
  padding: ${({ theme }) => theme.size.space['02']};
`

export const UploadedFileInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.size.space['03']};
  min-width: 0;
`

export const UploadedFileIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: ${({ theme }) => theme.size.space['02']};
  border-radius: ${({ theme }) => theme.size.border.radius['03']};
  background: ${({ theme }) => theme.color.feedback.action.subtle};
  color: ${({ theme }) => theme.color.feedback.action.default};
  width: ${({ theme }) => theme.size.space['08']};
  height: ${({ theme }) => theme.size.space['08']};

  svg {
    width: ${({ theme }) => theme.size.icon.medium};
    height: ${({ theme }) => theme.size.icon.medium};

    path {
      fill: ${({ theme }) => theme.color.feedback.action.default};
    }
  }
`

export const UploadedFileText = styled.div`
  ${columnLayoutStyles}
  gap: ${({ theme }) => theme.size.space['01']};
`

export const UploadedFileName = styled.span`
  ${labelRegularMainStyles}
  font-weight: ${({ theme }) => theme.font.weight.medium};
`

export const UploadedFileSize = styled.span`
  ${labelRegularSecondaryStyles}
`

export const UploadedFileAction = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.color.content.secondary};

  button {
    appearance: none;
    background: transparent;
    border: none;
    cursor: pointer;
    padding: 0;
    display: inline-flex;
    align-items: center;
    color: inherit;
  }

  svg {
    width: ${({ theme }) => theme.size.icon.small};
    height: ${({ theme }) => theme.size.icon.small};

    path {
      fill: ${({ theme }) => theme.color.content.secondary};
    }
  }
`

export const EmptyFormMessage = styled.p`
  ${labelRegularSecondaryStyles}
  margin: 0;
`
